import { Helpers } from '@app/shared/helpers';
import { BaseModel, BaseModelInterface } from '@app/abstracts';
import {
	FormationThematique,
	FormationThematiqueInterface,
} from '../formation-thematique/formation-thematique';
import {
	DocumentAdministrative,
	DocumentAdministrativeInterface,
} from '../document-administrative/document-administrative';
import { User, UserInterface } from '../user/user';
export interface AttestationPresenceThematiqueSummaryInterface
	extends BaseModelInterface {
	created_at: number | Date;
	thematique: string | FormationThematique | FormationThematiqueInterface;
	document: string | DocumentAdministrative | DocumentAdministrativeInterface;
	formateur: string | User | UserInterface;
}
export interface AttestationPresenceThematiqueSummaryPayload {
	thematique: string | FormationThematique | FormationThematiqueInterface;
	document: string | DocumentAdministrative | DocumentAdministrativeInterface;
	formateur: string | User | UserInterface;
}
type AttestationPresenceThematiqueSummaryPayloadKey =
	keyof AttestationPresenceThematiqueSummaryPayload;
export class AttestationPresenceThematiqueSummary extends BaseModel<
	AttestationPresenceThematiqueSummaryInterface,
	AttestationPresenceThematiqueSummaryPayload
> {
	/** Short function to get label of instance */
	getLabel(): string {
		return this.props._id;
	}
	/** Denotes if the instance of thematique has been populated */
	thematiqueExists(): boolean {
		return (
			!!this.props &&
			this.props.thematique instanceof FormationThematique &&
			this.props.thematique.exists()
		);
	}
	/** Denotes if the instance of document has been populated */
	documentExists(): boolean {
		return (
			!!this.props &&
			this.props.document instanceof DocumentAdministrative &&
			this.props.document.exists()
		);
	}
	/** Denotes if the instance of formateur has been populated */
	formateurExists(): boolean {
		return (
			!!this.props &&
			this.props.formateur instanceof User &&
			this.props.formateur.exists()
		);
	}
	/** Populate the current instance from an object */
	fromObject(object: AttestationPresenceThematiqueSummaryInterface): void {
		this.props = Object.assign({}, object);
		this.props.created_at = Helpers.convertToDate(this.props.created_at);
		if (typeof this.props.thematique === 'object') {
			this.props.thematique = new FormationThematique(
				<FormationThematiqueInterface>this.props.thematique
			);
		}
		if (typeof this.props.document === 'object') {
			this.props.document = new DocumentAdministrative(
				<DocumentAdministrativeInterface>this.props.document
			);
		}
		if (typeof this.props.formateur === 'object') {
			this.props.formateur = new User(
				<UserInterface>this.props.formateur
			);
		}
		this.next();
	}
	/** Convert the current instance to an object */
	toObject(): AttestationPresenceThematiqueSummaryInterface {
		const props = Object.assign({}, this.props);
		props.created_at = Helpers.convertToTimestamp(props.created_at);
		if (props.thematique instanceof FormationThematique) {
			props.thematique = props.thematique.toObject();
		}
		if (props.document instanceof DocumentAdministrative) {
			props.document = props.document.toObject();
		}
		if (props.formateur instanceof User) {
			props.formateur = props.formateur.toObject();
		}
		return props;
	}
	/** Convert an instance to an object to be sent to the API */
	toPayload(): AttestationPresenceThematiqueSummaryPayload {
		const raw = this.toObject();
		const allowed = this.allowedKeys();
		const payload = Object.keys(raw)
			.filter((key) => allowed.includes(<any>key))
			.reduce((o, k) => {
				o[k] = raw[k];
				return o;
			}, {} as AttestationPresenceThematiqueSummaryInterface);
		payload.thematique = payload.thematique
			? this.extractId(payload.thematique)
			: null;
		payload.document = payload.document
			? this.extractId(payload.document)
			: null;
		payload.formateur = payload.formateur
			? this.extractId(payload.formateur)
			: null;
		return payload as AttestationPresenceThematiqueSummaryPayload;
	}
	/** List allowed keys to be sent to the API */
	protected allowedKeys(): AttestationPresenceThematiqueSummaryPayloadKey[] {
		return ['thematique', 'document', 'formateur'];
	}
}
